import React from 'react'
import PropTypes from 'prop-types'

import { Header } from 'semantic-ui-react'

import * as styles from './styles'

const PreviewModalMeta = ({ children }) => (
  <div>
    <Header as="h4" style={styles.header}>
      {children}
    </Header>
  </div>
)

PreviewModalMeta.propTypes = {
  children: PropTypes.node.isRequired,
}

export default PreviewModalMeta
